<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loadingRoles"
    >
      <b-row>
        <b-col
          v-if="$can('write', 'roles')"
          cols="12"
          sm="12"
          class="d-flex justify-content-end mb-2"
        >
          <b-button
            variant="primary"
            @click="$router.push('/users/roles/new')"
          >
            <span>Add Role</span>
          </b-button>
        </b-col>
        <b-col
          cols="12"
          sm="12"
        >
          <card-collapse
            v-for="role in roles"
            :key="role.name"
            title-class="d-flex justify-content-between"
          >
            <template #card-title>
              <span>{{ role.name }}</span>
            </template>
            <template>
              <roles-form :role="role" />
            </template>
          </card-collapse>
        </b-col>
      </b-row>

    </b-overlay>
  </div>
</template>
<script>
import {
  BOverlay, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import RolesForm from './RolesForm.vue'
import CardCollapse from '@/UI/CardCollapse.vue'
import useRolesList from '@/views/users/roles/userRolesList'
import store from '@/store'
import roleStoreModule from '@/views/users/roles/roleStoreModule'

export default {
  components: {
    RolesForm,
    BOverlay,
    BButton,
    BRow,
    BCol,
    CardCollapse,
  },
  setup() {
    // Register Role Module
    const ROLE_APP_STORE_MODULE_NAME = 'roles'

    // Register module
    if (!store.hasModule(ROLE_APP_STORE_MODULE_NAME)) {
      store.registerModule(ROLE_APP_STORE_MODULE_NAME, roleStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ROLE_APP_STORE_MODULE_NAME)) store.unregisterModule(ROLE_APP_STORE_MODULE_NAME)
    })

    const {
      roles,
      loadingRoles,
      fetchRoles,
    } = useRolesList()

    fetchRoles()
    return {
      roles,
      loadingRoles,
    }
  },
}
</script>
